import React, { useState } from 'react';
import PrincipalUsersTable from './tables/PrincipalUsersTable';
import { SectionHeader, BfiCustomStore } from '../common/SharedComponents';
import store, { searchActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

function PrincipalUsersSummary() {
    const searchState = useSelector((state) => state.searchState);
    const { dispatch } = store;

    const gridStore = new BfiCustomStore();

    const [filterTypeId, set_filterTypeId] = useState(0);

    const filterTypes = [
        { id: 0, name: 'E-Signed', sortOrder: 0 },
        { id: 1, name: 'Not E-Signed', sortOrder: 1 },
        { id: 2, name: 'All Accounts', sortOrder: 3 },
        { id: 3, name: 'Pend. Experience', sortOrder: 2 },
    ];

    const _onSearchChange = (event) => {
        dispatch(
            searchActions.setSearchText({
                searchText: {
                    ...searchState.searchText,
                    principalUser: event.target.value,
                },
            })
        );
    };

    return (
        <>
            <SectionHeader title='Manage Principal Users' />
            <div
                className='main-content'
                style={{ padding: 0, backgroundColor: '#f4f4f4' }}
            >
                <div>
                    <div
                        className='input-has-icon main-search'
                        style={{
                            width: 'calc(100% - 200px)',
                            borderBottom: '1px solid #cfcfe7',
                            padding: '.5625rem 0 0 0.937rem',
                            height: '58px',
                            position: 'relative',
                            float: 'left',
                        }}
                    >
                        <input
                            type='search'
                            placeholder='Search to Filter Users'
                            value={searchState.searchText?.principalUser}
                            onChange={_onSearchChange}
                            style={{ paddingLeft: '30px' }}
                        />
                        <FontAwesomeIcon
                            icon={faSearch}
                            aria-hidden='true'
                            className='icon'
                        />
                    </div>
                    <div
                        className='main-search2'
                        style={{ width: '200px', paddingRight: '20px' }}
                    >
                        <select
                            id='loanTypeId'
                            value={filterTypeId}
                            onChange={(event) => set_filterTypeId(parseInt(event.target.value))}
                        >
                            {filterTypes
                                .sort((a, b) => a.sortOrder - b.sortOrder)
                                .map((fs) => {
                                    return (
                                        <option
                                            key={fs.id}
                                            value={fs.id}
                                        >
                                            {fs.name}
                                        </option>
                                    );
                                })}
                        </select>
                    </div>
                </div>
                <div className='scrollable-content'>
                    <div
                        className='accordion'
                        data-accordion=''
                        data-allow-all-closed='true'
                        data-multi-expand='true'
                    >
                        <PrincipalUsersTable
                            gridStore={gridStore}
                            filter={filterTypeId}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default PrincipalUsersSummary;
